import { IMPORT_BATCH_STATUSES } from "./importHistoryBatchModel";

const STATUS_LABELS = Object.freeze({
  [IMPORT_BATCH_STATUSES.UPLOADING]: "Uploading",
  [IMPORT_BATCH_STATUSES.PROCESSING]: "Organizing",
  [IMPORT_BATCH_STATUSES.READY]: "Needs review",
  [IMPORT_BATCH_STATUSES.PARTIAL_FAILURE]: "Needs attention",
  [IMPORT_BATCH_STATUSES.REVIEWED]: "Complete",
  [IMPORT_BATCH_STATUSES.DISMISSED]: "Archived",
});

const timestampToDate = (value) => {
  if (value?.toDate) return value.toDate();
  if (value?.seconds) return new Date(value.seconds * 1000);
  if (value instanceof Date) return value;
  return value ? new Date(value) : null;
};

export const getImportBatchStatusLabel = (batch = {}) => STATUS_LABELS[batch.status] || "Import saved";

export const getImportBatchDateLabel = (batch = {}) => {
  const date = timestampToDate(batch.createdAt);
  if (!date || Number.isNaN(date.getTime())) return "Import date unavailable";
  return new Intl.DateTimeFormat("en-US", { month: "short", day: "numeric", year: "numeric" }).format(date);
};

export const getImportBatchFileCount = (batch = {}) => (batch.items || []).length;

export const getImportBatchSuccessfulFileCount = (batch = {}) => (
  (batch.items || []).filter((item) => item.uploadStatus !== "failed" && item.sourceNoteId).length
);
